module.exports = __webpack_public_path__ + "static/media/icon-stopwatch.60624aaf.svg";